import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./FormStyles.css";
import "./UnifiedFormStyles.css";

function MerchantOtherSolution({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    is_grab_merchant: false,
    is_food_panda_merchant: false,
  });

  const YES_NO_OPTIONS = ["Yes", "No"];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({ ...prev, [name]: value }));
    if (isError[name]) {
      setIsError(prev => ({ ...prev, [name]: false }));
    }
  };

  const validateForm = () => {
    const errors = {
      is_grab_merchant: !primaryDetails.is_grab_merchant,
      is_food_panda_merchant: !primaryDetails.is_food_panda_merchant,
    };

    setIsError(errors);

    const hasErrors = Object.values(errors).some(error => error);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const isFormValid = () => {
    return !!primaryDetails.is_grab_merchant && !!primaryDetails.is_food_panda_merchant;
  };
  const handleSubmit = () => {
    if (validateForm()) {
      navigation.go("competitor-promo-consumers");
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">Merchant Other Solution</h4>
              <p className="form-desc">Please provide other merchant solution details</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">

                  {/* Grab Merchant */}
                  <Form.Group className="mb-5" controlId="is_grab_merchant">
                    <Form.Label className="form-label">
                      Grab Merchant <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {YES_NO_OPTIONS.map((option, index) => (
                        <div
                          key={`grab-${index}-${option}`}
                          className={`form-radio-item${primaryDetails.is_grab_merchant === option ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="is_grab_merchant"
                              value={option}
                              label={option}
                              onChange={handleInputChange}
                              checked={primaryDetails.is_grab_merchant === option}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {isError.is_grab_merchant && (
                      <div className="form-error">Please select an option</div>
                    )}
                  </Form.Group>

                  {/* Food Panda Merchant */}
                  <Form.Group className="mb-5" controlId="is_food_panda_merchant">
                    <Form.Label className="form-label">
                      Food Panda Merchant <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {YES_NO_OPTIONS.map((option, index) => (
                        <div
                          key={`foodpanda-${index}-${option}`}
                          className={`form-radio-item${primaryDetails.is_food_panda_merchant === option ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="is_food_panda_merchant"
                              value={option}
                              label={option}
                              onChange={handleInputChange}
                              checked={primaryDetails.is_food_panda_merchant === option}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {isError.is_food_panda_merchant && (
                      <div className="form-error">Please select an option</div>
                    )}
                  </Form.Group>

                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleSubmit}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MerchantOtherSolution;